import { graphql } from 'gql';

export const getWorkOrderChange = graphql(`
    query uerWorkOrderChange($workOrderChangeId: Long!) {
        uerWorkOrderChange(workOrderChangeId: $workOrderChangeId) {
            data {
                id
                contractId
                workOrderId
                contractSubjectText
                workOrderNumberText
                workOrderSigningDate
                status
                statusFollowers
                internalNumber
                workOrderSigningDate
                signingDate
                description
                createdAt
                updatedAt
                authoredBy
                statusFollowers
                draftCount
                isClosing
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const createWorkOrderChange = graphql(`
    mutation uerCreateWorkOrderChange($input: WorkOrderChangeInput!) {
        uerCreateWorkOrderChange(input: $input) {
            data {
                id
                contractId
                workOrderId
                contractSubjectText
                workOrderNumberText
                workOrderSigningDate
                status
                internalNumber
                signingDate
                description
                createdAt
                updatedAt
                authoredBy
                statusFollowers
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const deleteWorkOrderChange = graphql(`
    mutation uerDeleteWorkOrderChange($workOrderChangeId: Long!) {
        uerDeleteWorkOrderChange(workOrderChangeId: $workOrderChangeId) {
            id
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const updateWorkOrderChange = graphql(`
    mutation uerUpdateWorkOrderChange($workOrderChangeInput: WorkOrderChangeUpdateInput!) {
        uerUpdateWorkOrderChange(workOrderChangeInput: $workOrderChangeInput) {
            data {
                id
                statusFollowers
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const getWorkOrderChangeStatuses = graphql(`
    query uerWorkOrderChangeStatuses {
        uerWorkOrderChangeStatuses {
            data {
                status
                followers
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const checkIsUniqueWorkOrderChangeInternalNumber = graphql(`
    query uerIsUniqueWorkOrderChangeInternalNumber($workOrderChangeId: Long, $number: String!, $workOrderId: Long!) {
        uerIsUniqueWorkOrderChangeInternalNumber(
            workOrderChangeId: $workOrderChangeId
            number: $number
            workOrderId: $workOrderId
        ) {
            result
            message
            code
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const getWorkOrderChangeObjects = graphql(`
    query uerWorkOrderChangeObjectItems($workOrderChangeId: Long!, $where: WorkOrderChangeObjectItemFilterInput) {
        uerWorkOrderChangeObjectItems(workOrderChangeId: $workOrderChangeId, where: $where) {
            items {
                id
                code
                constructionType {
                    code
                    id
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                contractObject {
                    id
                    parentId
                    rootObjectId
                    constructionType {
                        id
                        code
                        name
                        shortName
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    contractId
                    fromVOR
                    name
                    status
                }
                hasAcceptedCost
                isAddedObject
                isLeaf
                isRemovedObject
                name
                objectUniqueId
                parentId
                rootObjectId
                rootObjectUniqueId
                workOrderChangeId
                workOrderObjectId
                workOrderChangeObjectId
                isActKC2WorkOrderObject
                workOrderChangeParentId
                workOrderChangeRootObjectId
                workOrderId
                workOrderParentId
                workOrderRootObjectId
            }
        }
    }
`);

export const getWorkOrderChangePriceList = graphql(`
    query uerWorkOrderChangePriceList(
        $skip: Int
        $take: Int
        $workOrderChangeId: Long!
        $workOrderObjectId: Long
        $workOrderChangeObjectId: Long
        $chapter: ChapterEnum!
        $where: WorkOrderChangePriceDataFilterInput
    ) {
        uerWorkOrderChangePriceList(
            skip: $skip
            take: $take
            workOrderChangeId: $workOrderChangeId
            workOrderObjectId: $workOrderObjectId
            workOrderChangeObjectId: $workOrderChangeObjectId
            chapter: $chapter
            where: $where
        ) {
            items {
                clientId
                clientParentId
                workOrderChangePriceId
                workOrderPriceId
                workOrderChangePriceParentId
                workOrderPriceParentId
                uerCodeId
                rationale
                type
                typeVal
                status
                chapter
                uerId
                uerCode
                priceListId
                code
                name
                unit
                unitCost
                totalPlanCost
                totalPlanVolume
                totalCompletedCost
                totalCompletedVolume
                totalRemainderCost
                totalRemainderVolume
                totalDeviation
                totalDeviationTip
                seasonPrices {
                    workOrderChangePriceId
                    workOrderPriceId
                    workOrderChangeSeasonId
                    year
                    planVolume
                    planCost
                    remainderVolume
                    remainderCost
                    deviation
                    deviationTip
                    planVolumeTerms
                    workOrderSeasonId
                    completedVolume
                    completedCost
                }
                hasAcceptedCost
                isRemovedPrice
                isAddedPrice
                isBlockedPrice
                isActKC2Price
                isExcludedPrice
                hasEmptySeasonVolume
                workCode
                workCompleted
                workInSum
                workName
                workPlan
                workRatio
                workReminder
                workUnit
                hasDuplicates
            }
            totalCount
        }
    }
`);

export const getWorkOrderSeasons = graphql(`
    query uerWorkOrderChangeSeasons($workOrderChangeId: Long!) {
        uerWorkOrderChangeSeasons(workOrderChangeId: $workOrderChangeId) {
            items {
                id
                workOrderSeasonId
                year
            }
        }
    }
`);

export const getWorkOrderChangeOtherPriceList = graphql(`
    query uerWorkOrderChangeOtherPriceList(
        $skip: Int
        $take: Int
        $workOrderChangeId: Long!
        $workOrderObjectId: Long
        $workOrderChangeObjectId: Long
        $where: WorkOrderChangeOtherPriceDataFilterInput
    ) {
        uerWorkOrderChangeOtherPriceList(
            skip: $skip
            take: $take
            workOrderChangeId: $workOrderChangeId
            workOrderObjectId: $workOrderObjectId
            workOrderChangeObjectId: $workOrderChangeObjectId
            where: $where
        ) {
            items {
                clientId
                workOrderChangeOtherPriceId
                workOrderOtherPriceId
                contractOtherId
                rationale
                name
                calculatingType
                calculatingTypeValue
                chapter
                section
                status
                totalPlanCost
                totalCompletedCost
                totalRemainderCost
                totalDeviation
                totalDeviationTip
                seasonPrices {
                    workOrderChangeOtherPriceId
                    workOrderOtherPriceId
                    workOrderChangeSeasonId
                    workOrderSeasonId
                    year
                    planCost
                    completedCost
                    remainderCost
                    deviation
                    deviationTip
                    hasErrors
                    errors
                }
                hasAcceptedCost
                hasEmptySeasonCost
                isAddedPrice
                isRemovedPrice
                isActKC2Price
                isExcludedPrice
                hasLimitSpan
            }
            totalCount
        }
    }
`);

export const uerRemoveWorkOrderChangePriceItemsGql = graphql(`
    mutation uerRemoveWorkOrderChangePriceItems(
        $workOrderChangeId: Long!
        $constructionTypeId: Int!
        $priceIds: [WorkOrderChangePriceIdsInput!]!
        $otherPriceIds: [WorkOrderChangeOtherPriceIdsInput!]!
    ) {
        uerRemoveWorkOrderChangePriceItems(
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            priceIds: $priceIds
            otherPriceIds: $otherPriceIds
        ) {
            result
            data {
                count
            }
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const removeWorkOrderChangePrices = graphql(`
    mutation uerRemoveWorkOrderChangePrices($workOrderChangeId: Long!, $priceIds: [WorkOrderChangePriceIdsInput!]!) {
        uerRemoveWorkOrderChangePrices(workOrderChangeId: $workOrderChangeId, priceIds: $priceIds) {
            result
            data
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const getWorkOrderChangeMtrPriceList = graphql(`
    query uerWorkOrderChangePriceListMtrQuery(
        $skip: Int
        $take: Int
        $workOrderChangePriceId: Long
        $workOrderPriceId: Long
        $where: PriceListMtrRowDataFilterInput
        $order: [PriceListMtrRowDataSortInput!]
    ) {
        uerWorkOrderChangePriceListMtrQuery(
            skip: $skip
            take: $take
            workOrderChangePriceId: $workOrderChangePriceId
            workOrderPriceId: $workOrderPriceId
            where: $where
            order: $order
        ) {
            items {
                id
                contractId
                code
                name
                unit
                volume
                unitWeight
                unitCost
                supplyBy
                supplyBasis
                mtrType
                pricingType
                note
                status
                isIncludedInWorkOrder
                isIncludedInAct
                justification
                mtrSupplyAndType
                hasDuplicateNeighbours
            }
            totalCount
        }
    }
`);

export const addMtrToWorkOrderChange = graphql(`
    mutation uerAddMtrToWorkOrderChange(
        $workOrderChangePriceId: Long
        $workOrderPriceId: Long
        $mtrInputs: [PriceListMtrRowInput!]!
    ) {
        uerAddMtrToWorkOrderChange(
            workOrderChangePriceId: $workOrderChangePriceId
            workOrderPriceId: $workOrderPriceId
            mtrInputs: $mtrInputs
        ) {
            data
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const getWorkOrderChangeUerPriceList = graphql(`
    query uerWorkOrderChangePriceListUerQuery(
        $chapter: ChapterEnum!
        $skip: Int
        $take: Int
        $where: PriceListUerRowDataFilterInput
        $workOrderChangeId: Long!
        $workOrderChangeObjectId: Long
        $workOrderObjectId: Long
    ) {
        uerWorkOrderChangePriceListUerQuery(
            skip: $skip
            take: $take
            workOrderObjectId: $workOrderObjectId
            workOrderChangeId: $workOrderChangeId
            workOrderChangeObjectId: $workOrderChangeObjectId
            chapter: $chapter
            where: $where
        ) {
            items {
                basePrice {
                    ozp
                    emm
                    zpm
                    mtr
                    eqp
                    pir
                    trn
                    nr
                    sp
                    unitCost
                    constructionTypeRelationStatus
                }
                currentPrices {
                    id
                    constructionTypeId
                    constructionTypeName
                    unitCostWithOther
                    ozp
                    emm
                    zpm
                    mtr
                    eqp
                    pir
                    trn
                    nr
                    sp
                    unitCost
                    constructionTypeRelationStatus
                }
                hasNewConstructionTypeRelations
                isIncludedInWorkOrder
                isIncludedInAct
                workScopes {
                    id
                    number
                    description
                }
                id
                sectionId
                sectionName
                groupId
                groupCode
                groupName
                unit
                code
                name
                chapter
                uerClassifier
                status
                linkStatus
                justification
            }
            totalCount
        }
    }
`);

export const addUerToWorkOrderChange = graphql(`
    mutation uerAddUerToWorkOrderChange(
        $chapter: ChapterEnum!
        $uerInputs: [PriceListUerRowInput!]!
        $workOrderChangeId: Long!
        $workOrderChangeObjectId: Long
        $workOrderObjectId: Long
    ) {
        uerAddUerToWorkOrderChange(
            workOrderChangeObjectId: $workOrderChangeObjectId
            chapter: $chapter
            uerInputs: $uerInputs
            workOrderChangeId: $workOrderChangeId
            workOrderObjectId: $workOrderObjectId
        ) {
            data
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const getWorkOrderChangeRatioPriceList = graphql(`
    query uerWorkOrderChangePriceListRatioQuery(
        $skip: Int
        $take: Int
        $workOrderChangePriceId: Long
        $workOrderPriceId: Long
        $where: PriceListRatioRowDataFilterInput
    ) {
        uerWorkOrderChangePriceListRatioQuery(
            skip: $skip
            take: $take
            workOrderChangePriceId: $workOrderChangePriceId
            workOrderPriceId: $workOrderPriceId
            where: $where
        ) {
            items {
                appliesToCode
                appliesToCodeName
                appliesToFullName
                appliesToId
                appliesToLinkStatus
                code
                groupId
                groupIsArtificial
                groupName
                groupType
                id
                isCustom
                isIncludedInAct
                isIncludedInWorkOrder
                isIncludedInWorkOrderChange
                justification
                kem
                kmat
                knr
                kozp
                ksp
                ktz
                ktzzpm
                number
                ratioType
                status
                subGroupId
                subGroupName
                uerPriceListGroupCode
                uerPriceListGroupFullName
                uerPriceListGroupId
                uerPriceListGroupName
                uerPriceListSectionId
                uerPriceListSectionName
                workConditions
            }
            totalCount
        }
    }
`);

export const addRatioToWorkOrderChange = graphql(`
    mutation uerAddRatioToWorkOrderChange(
        $workOrderChangePriceId: Long
        $workOrderPriceId: Long
        $ratioInputs: [PriceListRatioRowInput!]!
        $strategy: AddRatioToActKc2StrategyEnum
    ) {
        uerAddRatioToWorkOrderChange(
            workOrderChangePriceId: $workOrderChangePriceId
            workOrderPriceId: $workOrderPriceId
            ratioInputs: $ratioInputs
            strategy: $strategy
        ) {
            data
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const saveOrUpdateWorkOrderChangeSeasonVolumeGql = graphql(`
    mutation uerSaveOrUpdateWorkOrderChangeSeasonVolume(
        $volume: Decimal!
        $workOrderChangeId: Long!
        $workOrderChangeSeasonId: Long!
        $workOrderChangePriceId: Long
        $workOrderPriceId: Long
    ) {
        uerSaveOrUpdateWorkOrderChangeSeasonVolume(
            volume: $volume
            workOrderChangeId: $workOrderChangeId
            workOrderChangeSeasonId: $workOrderChangeSeasonId
            workOrderChangePriceId: $workOrderChangePriceId
            workOrderPriceId: $workOrderPriceId
        ) {
            data
            result
            code
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const workOrderChangeObjectResultGql = graphql(`
    query uerWorkOrderChangeObjectResult(
        $chapter: ChapterEnum
        $order: [WorkOrderChangeObjectResultDataSortInput!]
        $section: SectionEnum
        $where: WorkOrderChangeObjectResultDataFilterInput
        $workOrderChangeId: Long!
        $workOrderChangeObjectId: Long
        $workOrderObjectId: Long
    ) {
        uerWorkOrderChangeObjectResult(
            chapter: $chapter
            section: $section
            where: $where
            order: $order
            workOrderChangeId: $workOrderChangeId
            workOrderObjectId: $workOrderObjectId
            workOrderChangeObjectId: $workOrderChangeObjectId
        ) {
            chapter
            constructionTypeId
            costResultData {
                name
                value
                year
            }
            section
            sortOrder
            title
            workOrderChangeObjectId
            workOrderObjectId
        }
    }
`);

export const workOrderChangeResultGql = graphql(`
    query uerWorkOrderChangeResult(
        $order: [WorkOrderChangeResultDataSortInput!]
        $where: WorkOrderChangeResultDataFilterInput
        $workOrderChangeId: Long!
    ) {
        uerWorkOrderChangeResult(workOrderChangeId: $workOrderChangeId, where: $where, order: $order) {
            chapter
            resultSectionId
            seasonResults {
                seasonId
                value
            }
            section
            sortOrder
            title
            totalCompletedCost
            totalPlanCost
            totalRemainderCost
        }
    }
`);

export const getOtherToWorkOrderChangePriceList = graphql(`
    query uerWorkOrderChangeOtherListQuery(
        $skip: Int
        $take: Int
        $workOrderChangeId: Long!
        $constructionTypeId: Int!
        $where: WorkOrderChangeOtherAggregationDataFilterInput
    ) {
        uerWorkOrderChangeOtherListQuery(
            take: $take
            skip: $skip
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            where: $where
        ) {
            items {
                limits {
                    season {
                        id
                        workOrderSeasonId
                        year
                    }
                    costLimit
                    totalRemainderCost
                    deviation
                }
                contractOtherCostId
                name
                calculatingType
                calculatingTypeValue
                chapter
                section
                status
            }
            totalCount
        }
    }
`);

export const addOthersToWorkOrderChange = graphql(`
    mutation uerAddWorkOrderChangeOtherCost($input: WorkOrderChangeOthersInput!) {
        uerAddWorkOrderChangeOtherCost(input: $input) {
            data
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
            result
        }
    }
`);

export const removeOthersFromWorkOrderChange = graphql(`
    mutation uerRemoveWorkOrderChangeOtherCost(
        $workOrderChangeId: Long!
        $workOrderChangeOtherPriceIds: [WorkOrderChangeOtherPriceIdsInput!]!
    ) {
        uerRemoveWorkOrderChangeOtherCost(
            workOrderChangeId: $workOrderChangeId
            workOrderChangeOtherPriceIds: $workOrderChangeOtherPriceIds
        ) {
            data
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const workOrderChangeOtherForDistribution = graphql(`
    query uerWorkOrderChangeOtherForDistribution(
        $workOrderChangeId: Long!
        $workOrderChangeOtherPriceId: Long
        $workOrderOtherPriceId: Long
    ) {
        uerWorkOrderChangeOtherForDistribution(
            workOrderChangeId: $workOrderChangeId
            workOrderChangeOtherPriceId: $workOrderChangeOtherPriceId
            workOrderOtherPriceId: $workOrderOtherPriceId
        ) {
            data {
                workOrderChangeOtherPriceId
                workOrderOtherPriceId
                contractOtherCost {
                    id
                    key
                    name
                    calculatingType
                    calculatingTypeValue
                    chapter
                    section
                    isGlobalOtherCost
                    status
                    canEdit
                    canDelete
                    isInUse
                }
                objects {
                    rootObjectId {
                        workOrderObjectId
                        workOrderChangeObjectId
                    }
                    hasActualCost
                    isActKC2Cost
                    contractObjectId
                    name
                    rationale
                    isIncluded
                    canAddOther
                    canRemoveOther
                }
                limits {
                    includedCost
                    isIncluded
                    season {
                        id
                        workOrderSeasonId
                        year
                    }
                    costLimit
                    totalRemainderCost
                    deviation
                    isSystemCalculation
                }
                objectSeasonDistributions {
                    isIncluded
                    hasErrors
                    errors
                    seasonId
                    cost
                    workOrderChangeObjectId
                    workOrderObjectId
                }
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerUpdateWorkOrderChangeOtherCostGql = graphql(`
    mutation uerUpdateWorkOrderChangeOtherDistribution(
        $workOrderChangeId: Long!
        $workOrderChangeOtherPriceId: Long
        $workOrderOtherPriceId: Long
        $input: WorkOrderChangeOtherCostDistributionInput!
    ) {
        uerUpdateWorkOrderChangeOtherDistribution(
            workOrderChangeId: $workOrderChangeId
            workOrderChangeOtherPriceId: $workOrderChangeOtherPriceId
            workOrderOtherPriceId: $workOrderOtherPriceId
            input: $input
        ) {
            data
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerUpdateContractOtherCostToWorkOrderChangeFromPriceListGql = graphql(`
    mutation uerUpdateContractOtherCostToWorkOrderChangeFromPriceList(
        $input: ContractOtherUpdateInput!
        $workOrderChangeOtherPriceId: Long!
    ) {
        uerUpdateContractOtherCostToWorkOrderChangeFromPriceList(
            workOrderChangeOtherPriceId: $workOrderChangeOtherPriceId
            input: $input
        ) {
            id
            result
            message
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const updateWorkOrderChangeMtr = graphql(`
    mutation uerUpdateMtrToWorkOrderChangeFromPriceList(
        $workOrderChangePriceId: Long!
        $input: PriceListMtrRowUpdateInput!
    ) {
        uerUpdateMtrToWorkOrderChangeFromPriceList(workOrderChangePriceId: $workOrderChangePriceId, input: $input) {
            id
            result
            message
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const workOrderChangePriceStatusFilterGql = graphql(`
    query uerWorkOrderChangePriceStatusFilter(
        $chapter: ChapterEnum!
        $where: FilterValueOfNullableOfWorkOrderPriceStatusEnumFilterInput
        $workOrderChangeId: Long!
        $workOrderChangeObjectId: Long
        $workOrderObjectId: Long
    ) {
        uerWorkOrderChangePriceStatusFilter(
            chapter: $chapter
            where: $where
            workOrderChangeId: $workOrderChangeId
            workOrderChangeObjectId: $workOrderChangeObjectId
            workOrderObjectId: $workOrderObjectId
        ) {
            items {
                value
            }
        }
    }
`);

export const workOrderChangePriceCodeFilterGql = graphql(`
    query uerWorkOrderChangePriceCodeFilter(
        $chapter: ChapterEnum!
        $where: FilterValueOfWorkOrderChangePriceCodeFilterDataFilterInput
        $workOrderChangeId: Long!
        $workOrderChangeObjectId: Long
        $workOrderObjectId: Long
    ) {
        uerWorkOrderChangePriceCodeFilter(
            chapter: $chapter
            where: $where
            workOrderChangeId: $workOrderChangeId
            workOrderChangeObjectId: $workOrderChangeObjectId
            workOrderObjectId: $workOrderObjectId
        ) {
            items {
                value {
                    parentCode
                    code
                }
            }
        }
    }
`);

export const workOrderChangePriceNameFilterGql = graphql(`
    query uerWorkOrderChangePriceNameFilter(
        $chapter: ChapterEnum!
        $where: FilterValueOfStringFilterInput
        $workOrderChangeId: Long!
        $workOrderChangeObjectId: Long
        $workOrderObjectId: Long
    ) {
        uerWorkOrderChangePriceNameFilter(
            chapter: $chapter
            where: $where
            workOrderChangeId: $workOrderChangeId
            workOrderChangeObjectId: $workOrderChangeObjectId
            workOrderObjectId: $workOrderObjectId
        ) {
            items {
                value
            }
        }
    }
`);

export const uerWorkOrderChangeSeasonPricePlanVolumeFilterGql = graphql(`
    query uerWorkOrderChangeSeasonPricePlanVolumeFilter(
        $chapter: ChapterEnum!
        $seasonId: Long!
        $where: FilterValueOfNullableOfDecimalFilterInput
        $workOrderChangeId: Long!
        $workOrderChangeObjectId: Long
        $workOrderObjectId: Long
    ) {
        uerWorkOrderChangeSeasonPricePlanVolumeFilter(
            chapter: $chapter
            seasonId: $seasonId
            where: $where
            workOrderChangeId: $workOrderChangeId
            workOrderChangeObjectId: $workOrderChangeObjectId
            workOrderObjectId: $workOrderObjectId
        ) {
            items {
                value
            }
        }
    }
`);

export const uerWorkOrderChangeSeasonPriceCompletedVolumeFilterGql = graphql(`
    query uerWorkOrderChangeSeasonPriceCompletedVolumeFilter(
        $chapter: ChapterEnum!
        $seasonId: Long!
        $where: FilterValueOfNullableOfDecimalFilterInput
        $workOrderChangeId: Long!
        $workOrderChangeObjectId: Long
        $workOrderObjectId: Long
    ) {
        uerWorkOrderChangeSeasonPriceCompletedVolumeFilter(
            chapter: $chapter
            seasonId: $seasonId
            where: $where
            workOrderChangeId: $workOrderChangeId
            workOrderChangeObjectId: $workOrderChangeObjectId
            workOrderObjectId: $workOrderObjectId
        ) {
            items {
                value
            }
        }
    }
`);

export const uerWorkOrderChangeSeasonPriceRemainderVolumeFilterGql = graphql(`
    query uerWorkOrderChangeSeasonPriceRemainderVolumeFilter(
        $chapter: ChapterEnum!
        $seasonId: Long!
        $where: FilterValueOfNullableOfDecimalFilterInput
        $workOrderChangeId: Long!
        $workOrderChangeObjectId: Long
        $workOrderObjectId: Long
    ) {
        uerWorkOrderChangeSeasonPriceRemainderVolumeFilter(
            chapter: $chapter
            seasonId: $seasonId
            where: $where
            workOrderChangeId: $workOrderChangeId
            workOrderChangeObjectId: $workOrderChangeObjectId
            workOrderObjectId: $workOrderObjectId
        ) {
            items {
                value
            }
        }
    }
`);

export const workOrderChangeOtherPriceNameFilterGql = graphql(`
    query uerWorkOrderChangeOtherPriceNameFilter(
        $where: FilterValueOfStringFilterInput
        $workOrderChangeId: Long!
        $workOrderChangeObjectId: Long
        $workOrderObjectId: Long
    ) {
        uerWorkOrderChangeOtherPriceNameFilter(
            where: $where
            workOrderChangeId: $workOrderChangeId
            workOrderChangeObjectId: $workOrderChangeObjectId
            workOrderObjectId: $workOrderObjectId
        ) {
            items {
                value
            }
        }
    }
`);

export const workOrderChangeOtherPriceStatusFilterGql = graphql(`
    query uerWorkOrderChangeOtherPriceStatusFilter(
        $where: FilterValueOfNullableOfContractOtherStatusEnumFilterInput
        $workOrderChangeId: Long!
        $workOrderChangeObjectId: Long
        $workOrderObjectId: Long
    ) {
        uerWorkOrderChangeOtherPriceStatusFilter(
            where: $where
            workOrderChangeId: $workOrderChangeId
            workOrderChangeObjectId: $workOrderChangeObjectId
            workOrderObjectId: $workOrderObjectId
        ) {
            items {
                value
            }
        }
    }
`);

export const uerUpdateOrderChangePriceRationaleGql = graphql(`
    mutation uerUpdateOrderChangePriceRationale(
        $workOrderChangePriceId: Long
        $workOrderPriceId: Long
        $input: WorkOrderChangePriceRationaleUpdateInput!
    ) {
        uerUpdateOrderChangePriceRationale(
            workOrderChangePriceId: $workOrderChangePriceId
            workOrderPriceId: $workOrderPriceId
            input: $input
        ) {
            message
            result
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const uerUpdateOrderChangeOtherPriceRationaleGql = graphql(`
    mutation uerUpdateOrderChangeOtherPriceRationale(
        $workOrderChangeOtherPriceId: Long
        $workOrderOtherPriceId: Long
        $input: WorkOrderChangeOtherPriceRationaleUpdateInput!
    ) {
        uerUpdateOrderChangeOtherPriceRationale(
            workOrderChangeOtherPriceId: $workOrderChangeOtherPriceId
            workOrderOtherPriceId: $workOrderOtherPriceId
            input: $input
        ) {
            message
            result
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const uerWorkOrderChangeUerRemaindersGql = graphql(`
    query uerWorkOrderChangeUerRemainders(
        $chapter: ChapterEnum!
        $workOrderChangeId: Long!
        $workOrderChangePriceId: Long
        $workOrderPriceId: Long
    ) {
        uerWorkOrderChangeUerRemainders(
            chapter: $chapter
            workOrderChangeId: $workOrderChangeId
            workOrderChangePriceId: $workOrderChangePriceId
            workOrderPriceId: $workOrderPriceId
        ) {
            clientId
            code
            name
            reminderData {
                completedVolume
                planVolume
                remainderVolume
                seasonId
                seasonYear
            }
            type
            workOrderChangePriceId
            workOrderPriceId
        }
    }
`);

export const uerMoveWorkOrderChangeUerRemindersGql = graphql(`
    mutation uerMoveWorkOrderChangeUerReminders($input: WorkOrderChangeUerVolumesTransferInput!) {
        uerMoveWorkOrderChangeUerReminders(input: $input) {
            message
            result
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const uerWorkOrderChangeObjectsForRemindersGql = graphql(`
    query uerWorkOrderChangeObjectsForReminders(
        $workOrderChangeId: Long!
        $workOrderChangeRootObjectId: Long
        $workOrderRootObjectId: Long
    ) {
        uerWorkOrderChangeObjectsForReminders(
            workOrderChangeId: $workOrderChangeId
            workOrderChangeRootObjectId: $workOrderChangeRootObjectId
            workOrderRootObjectId: $workOrderRootObjectId
        ) {
            data {
                code
                constructionType {
                    code
                    id
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                hasAcceptedCost
                id
                isAddedObject
                isLeaf
                isRemovedObject
                name
                parentId
                rootObjectId
                workOrderChangeId
                workOrderObjectId
                workOrderParentId
                workOrderRootObjectId
            }
            message
            result
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const uerMoveWorkOrderChangeObjectRemindersGql = graphql(`
    mutation uerMoveWorkOrderChangeObjectReminders($input: WorkOrderChangeObjectVolumesTransferInput!) {
        uerMoveWorkOrderChangeObjectReminders(input: $input) {
            message
            result
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const updateWorkOrderChangeUerGql = graphql(`
    mutation uerUpdateUerToWorkOrderChangeFromPriceList(
        $workOrderChangePriceId: Long!
        $input: PriceListUerRowUpdateInput!
    ) {
        uerUpdateUerToWorkOrderChangeFromPriceList(workOrderChangePriceId: $workOrderChangePriceId, input: $input) {
            id
            result
            message
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const updateWorkOrderChangeRatio = graphql(`
    mutation updateRatioToWorkOrderChangeFromPriceList(
        $workOrderChangePriceId: Long!
        $input: PriceListRatioRowUpdateInput!
    ) {
        uerUpdateRatioToWorkOrderChangeFromPriceList(workOrderChangePriceId: $workOrderChangePriceId, input: $input) {
            id
            result
            message
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerSetWorkOrderChangeWorkRatioGql = graphql(`
    mutation uerSetWorkOrderChangeWorkRatio($ratio: Decimal, $workOrderChangePriceId: Long, $workOrderPriceId: Long) {
        uerSetWorkOrderChangeWorkRatio(
            ratio: $ratio
            workOrderChangePriceId: $workOrderChangePriceId
            workOrderPriceId: $workOrderPriceId
        ) {
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerWorkOrderChangeObjectSelectionListGql = graphql(`
    query uerWorkOrderChangeObjectSelectionList(
        $workOrderChangeId: Long!
        $where: WorkOrderChangeObjectSelectionItemFilterInput
    ) {
        uerWorkOrderChangeObjectSelectionList(workOrderChangeId: $workOrderChangeId, where: $where) {
            items {
                codeWBS
                constructionType {
                    code
                    id
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                contractId
                fromVOR
                hasGuaranteedVolume
                id
                isIncluded
                name
                parentId
                rationale
                rootObjectId
                status
                workOrderChangeId
                workOrderChangeObjectId
                workOrderId
                workOrderObjectId
                hasActsKC2
                hasOtherPrices
                hasPrices
                isInUse
                isIncluded
                isActKC2WorkOrderObject
                isAddedObject
                isRemovedObject
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerWorkOrderChangeObjectSelectionListIsIncludedGql = graphql(`
    query uerWorkOrderChangeObjectSelectionListIsIncluded(
        $workOrderChangeId: Long!
        $where: WorkOrderChangeObjectSelectionItemFilterInput
    ) {
        uerWorkOrderChangeObjectSelectionList(workOrderChangeId: $workOrderChangeId, where: $where) {
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                isIncluded
                id
                constructionType {
                    id
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                fromVOR
            }
            totalCount
        }
    }
`);

export const uerIncludeContractObjectToWorkOrderChangeGql = graphql(`
    mutation uerIncludeContractObjectToWorkOrderChange($contractObjectId: Long!, $workOrderChangeId: Long!) {
        uerIncludeContractObjectToWorkOrderChange(
            contractObjectId: $contractObjectId
            workOrderChangeId: $workOrderChangeId
        ) {
            actionRequired
            buttonText
            code
            data
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerExcludeContractObjectFromWorkOrderChangeGql = graphql(`
    mutation uerExcludeContractObjectFromWorkOrderChange($contractObjectId: Long!, $workOrderChangeId: Long!) {
        uerExcludeContractObjectFromWorkOrderChange(
            contractObjectId: $contractObjectId
            workOrderChangeId: $workOrderChangeId
        ) {
            actionRequired
            buttonText
            code
            data
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerCreateWorkOrderChangeObjectGql = graphql(`
    mutation uerCreateWorkOrderChangeObject($input: ContractObjectCreateInput!, $workOrderChangeId: Long!) {
        uerCreateWorkOrderChangeObject(input: $input, workOrderChangeId: $workOrderChangeId) {
            actionRequired
            buttonText
            code
            id
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerCreateWorkOrderChangeSubObjectGql = graphql(`
    mutation uerCreateWorkOrderChangeSubObject($input: ContractSubObjectCreateInput!, $workOrderChangeId: Long!) {
        uerCreateWorkOrderChangeSubObject(input: $input, workOrderChangeId: $workOrderChangeId) {
            actionRequired
            buttonText
            code
            id
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerUpdateWorkOrderChangeObjectGql = graphql(`
    mutation uerUpdateWorkOrderChangeObject($input: ContractObjectUpdateInput!, $workOrderChangeId: Long!) {
        uerUpdateWorkOrderChangeObject(input: $input, workOrderChangeId: $workOrderChangeId) {
            actionRequired
            buttonText
            code
            id
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);
export const uerUpdateWorkOrderChangeSubObjectGql = graphql(`
    mutation uerUpdateWorkOrderChangeSubObject($input: ContractObjectUpdateInput!, $workOrderChangeId: Long!) {
        uerUpdateWorkOrderChangeSubObject(input: $input, workOrderChangeId: $workOrderChangeId) {
            actionRequired
            buttonText
            code
            id
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerRemoveWorkOrderChangeObjectItemGql = graphql(`
    mutation uerRemoveWorkOrderChangeObjectItem($contractObjectId: Long!, $workOrderChangeId: Long!) {
        uerRemoveWorkOrderChangeObjectItem(contractObjectId: $contractObjectId, workOrderChangeId: $workOrderChangeId) {
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerAddWorkOrderChangeFromXmlGql = graphql(`
    mutation uerAddWorkOrderChangeFromXml(
        $constructionTypeId: Int!
        $contractSeasonId: Long!
        $filesContent: [FileInput!]!
        $workOrderChangeId: Long!
    ) {
        uerAddWorkOrderChangeFromXml(
            constructionTypeId: $constructionTypeId
            contractSeasonId: $contractSeasonId
            filesContent: $filesContent
            workOrderChangeId: $workOrderChangeId
        ) {
            data {
                id
            }
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerSetWorkOrderChangeLastSeasonGql = graphql(`
    mutation uerSetWorkOrderChangeLastSeason($contractSeasonId: Long!, $workOrderChangeId: Long!) {
        uerSetWorkOrderChangeLastSeason(contractSeasonId: $contractSeasonId, workOrderChangeId: $workOrderChangeId) {
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerApplyMtrToWorkOrderChangeFromPriceListGql = graphql(`
    mutation uerApplyMtrToWorkOrderChangeFromPriceList($mtrRowId: Long!, $workOrderChangePriceId: Long!) {
        uerApplyMtrToWorkOrderChangeFromPriceList(
            mtrRowId: $mtrRowId
            workOrderChangePriceId: $workOrderChangePriceId
        ) {
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerWorkOrderChangeDraftInfoGql = graphql(`
    query uerWorkOrderChangeDraftInfo($workOrderChangeId: Long!) {
        uerWorkOrderChangeDraftInfo(workOrderChangeId: $workOrderChangeId) {
            actionRequired
            buttonText
            code
            data {
                draftCount
            }
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerWorkOrderChangeLastSeasonSelectionListGql = graphql(`
    query uerWorkOrderChangeLastSeasonSelectionList($where: ContractSeasonDataFilterInput, $workOrderChangeId: Long!) {
        uerWorkOrderChangeLastSeasonSelectionList(where: $where, workOrderChangeId: $workOrderChangeId) {
            id
            year
        }
    }
`);

export const uerWorkOrderChangeAllowedSeasonsGql = graphql(`
    query uerWorkOrderChangeAllowedSeasons($where: ContractSeasonDataFilterInput, $workOrderChangeId: Long!) {
        uerWorkOrderChangeAllowedSeasons(where: $where, workOrderChangeId: $workOrderChangeId) {
            id
            year
        }
    }
`);

export const uerWorkOrderChangeTotalsGql = graphql(`
    query uerWorkOrderChangeTotals($workOrderChangeId: Long!) {
        uerWorkOrderChangeTotals(workOrderChangeId: $workOrderChangeId) {
            actionRequired
            buttonText
            code
            data {
                isHeadLine
                name
                seasonTotals {
                    completedCost
                    planCost
                    seasonId
                }
                totalCompletedCost
                totalPlanCost
                totalRemainderCost
            }
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerWorkOrderChangeObjectTotalsGql = graphql(`
    query uerWorkOrderChangeObjectTotals(
        $workOrderChangeId: Long!
        $workOrderChangeObjectId: Long
        $workOrderObjectId: Long
    ) {
        uerWorkOrderChangeObjectTotals(
            workOrderChangeId: $workOrderChangeId
            workOrderChangeObjectId: $workOrderChangeObjectId
            workOrderObjectId: $workOrderObjectId
        ) {
            actionRequired
            buttonText
            code
            data {
                isHeadLine
                name
                seasonTotals {
                    completedCost
                    planCost
                    seasonId
                }
                totalCompletedCost
                totalPlanCost
                totalRemainderCost
            }
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerClosingWorkOrderChangeDefaultsGql = graphql(`
    query uerClosingWorkOrderChangeDefaults($workOrderId: Long!) {
        uerClosingWorkOrderChangeDefaults(workOrderId: $workOrderId) {
            actionRequired
            buttonText
            code
            data {
                authoredBy
                contractId
                contractSubjectText
                createdAt
                draftCount
                id
                isClosing
                status
                updatedAt
                workOrderId
                workOrderNumberText
                workOrderSigningDate
            }
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerCreateClosingWorkOrderChangeGql = graphql(`
    mutation uerCreateClosingWorkOrderChange($input: WorkOrderChangeClosingInput!) {
        uerCreateClosingWorkOrderChange(input: $input) {
            actionRequired
            buttonText
            code
            data {
                authoredBy
                contractId
                contractSubjectText
                createdAt
                description
                draftCount
                id
                internalNumber
                isClosing
                signingDate
                status
                statusFollowers
                updatedAt
                workOrderId
                workOrderNumberText
                workOrderSigningDate
            }
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);
